export default {
    init($) {
        let target = $('.company_registration #billing_state');
        if (target.length) {
            target.select2();
        }

    }
}